import { Component, input, Input, InputSignal } from '@angular/core';
import {
  ApplicationPayment,
  ApplicationPaymentRoadOccupation,
  CostPosition,
  RoadOccupationStage
} from '../../../../../../../services/application.common.model';
import { AccordionGroupComponent } from '../../../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../../../common/accordion-item/accordion-item.component';
import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { ToNumberPipe } from '../../../../../../../pipes/to-number.pipe';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { toNumber } from '../../../../../../../services/helpers';

@Component({
  selector: 'app-payments-data-preview',
  standalone: true,
  imports: [
    AccordionGroupComponent,
    AccordionItemComponent,
    CurrencyPipe,
    DatePipe,
    LabelComponent,
    CommonModule,
    ToNumberPipe,
    DecimalPipe
  ],
  templateUrl: './payments-data-preview.component.html'
})
export class PaymentsDataPreviewComponent {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public payment: InputSignal<ApplicationPayment | null> = input<ApplicationPayment | null>(null);

  public calcTotalStageCost(occupation: ApplicationPaymentRoadOccupation): string {
    let allCosts: number[] = [];
    occupation.stages.map(stage => this.getCostPositions(stage).map(costPosition => Number(costPosition.totalCost.replace(',', '.') || 0)).filter(c => !!c))
      .forEach(costs => {
        allCosts = allCosts.concat(costs);
      });
    let result: number = 0.00;
    allCosts.forEach(cost => {
      result = result + cost;
    });
    return result.toFixed(2);
  }

  public getCostPositions(v: RoadOccupationStage): CostPosition[] {
    return v.years[0]?.costPositions?.filter(v => !!v.area) || [];
  }

  protected readonly toNumber = toNumber;
}
